import { GlobalStyles, styled, useMediaQuery } from '@mui/material';
import { ThemeProvider } from 'src/lib/style';
import { buildVendorTheme } from '../VendorDashboard/theme';

interface AuthThemeProviderProps {
    children: React.ReactNode;
}

const AuthPageWrapper = styled('div')(({ theme }) => ({
    minHeight: '100vh',
    backgroundColor: theme.resqPalette.background.default,
    color: theme.resqPalette.text.default,
}));

/**
 * Theme provider for unauthenticated routes that automatically
 * follows the system's color scheme preference.
 */
export const AuthThemeProvider = ({ children }: AuthThemeProviderProps) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const mode = prefersDarkMode ? 'dark' : 'light';

    const theme = buildVendorTheme(mode);

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles
                styles={{
                    'body, html': {
                        backgroundColor: `${theme.resqPalette.background.default} !important`,
                        color: `${theme.resqPalette.text.default} !important`,
                    },
                }}
            />
            <AuthPageWrapper>{children}</AuthPageWrapper>
        </ThemeProvider>
    );
};
